import type { RoleCode } from './types';

/**
 * Where to send a user after a case-request action (save draft / submit / close cover note /
 * forward / revert) back to "their" task list. Some roles have a dedicated route instead of
 * the shared /tasks screen — Management Assistant's is blocked from /tasks entirely via
 * denyManagementAssistant, so hardcoding '/tasks' there is a hard failure, not just a wrong
 * destination. State Attorney isn't blocked from /tasks, so hardcoding it there was only ever
 * a silent wrong-tab redirect, not an error — fixed here too while we're at it.
 */
export function tasksListPathForRole(roleCode: RoleCode): string {
  if (roleCode === 'OFFICE_CLERK') return '/tasks/case-details';
  if (roleCode === 'STATE_ATTORNEY') return '/tasks/attending';
  if (roleCode === 'ALLOCATION_OFFICER') return '/tasks/assign';
  return '/tasks';
}
